// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

export const isGetEngagementReportBuilder2AppGroupIdSegmentIdentitiesResult = objectOf({
  identities: arrayOf(
    objectOf({
      segment_id: string,
      segment_name: string,
      segment_token: string,
    })
  ),
  errors: arrayOf(string),
});
